__turbopack_context__.v({
  "container": "SharingTruck-module__NG4bdG__container",
});
